import { render, staticRenderFns } from "./PropertyFormatPicker.vue?vue&type=template&id=77e5a88a&"
import script from "./PropertyFormatPicker.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PropertyFormatPicker.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports